<a (click)="goToPage(data?.url)"> {{ data?.url }} </a>
